import React, { PropTypes } from 'react'
import classnames from 'classnames'
import styles from '../../AutoCompleteInput.scss'

const SuggestionItem = (props) => {
  const {
    active,
    handleClick,
    label,
    value,
  } = props

  const classes = {
    [styles.active]: active,
  }

  const _handleClick = () => {
    handleClick({
      label,
      value,
    })
  }

  return (
    <div
      className={classnames(styles.option, classes)}
      onClick={_handleClick}
    >
      <span className={styles.optionText}>{label}</span>
    </div>
  )
}

SuggestionItem.propTypes = {
  active: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
}

export default SuggestionItem



// WEBPACK FOOTER //
// ./src/components/Form/components/AutoCompleteInput/components/SuggestionItem/SuggestionItem.js